<template>
  <div class="projects">
    <h3>Projects</h3>
    <div class="content">
      <div class="project-item">
        <p class="project-title">Microservices</p>
        <p class="project-desc">Development of MAP (Media Application Platform) using suite of AWS services</p>
        <p class="project-desc">(AWS - Lambda, API Gateway, S3, DynamoDB, Cognito, SNS, Cloudfront).</p>
      </div>
      <div class="project-item">
        <p class="project-title">Emoji CMS</p>
        <p class="project-desc">Managing and developing the CMS that supports the Emoji business that includes Container apps, sticker packs and keyboard extensions on iOS platform</p>
        <p class="project-desc">(1M+ downloads and 100k+ daily active users)</p>
      </div>
      <div class="project-item">
        <p class="project-title">Stoopidland</p>
        <p class="project-desc">Lead the development of Container, Keyboard extension and Sticker extension for the Stoopidland Project</p>
        <p class="project-desc">(Swift, Realm, In-app purchases, configs, analytics)</p>
      </div>
      <div class="project-item">
        <a class="project-title" href="http://ehow.com" target="_blank">eHow</a>
        <p class="project-desc">DIY site getting 75 Million+ visits/month</p>
        <p class="project-desc">(Javascript, NodeJS, Firebase, React, Redux, EmberJS, New Relic)</p>
      </div>
      <div class="project-item">
        <a class="project-title" href="http://techwalla.com/" target="_blank">Techwalla</a>
        <p class="project-desc">Tech review site that provides metacritic data</p>
        <p class="project-desc">Lead the development of UI/UX on the site</p>
      </div>
      <div class="project-item">
        <a class="project-title" href="https://animeshmanglik.name/" target="_blank">animeshmanglik.name</a>
        <p class="project-desc">Resume TL; DR</p>
        <p class="project-desc">(VueJS, AWS, NodeJS)</p>
      </div>
    </div>
  </div>
</template>

<style type="text/css">
  .projects {
    padding: 10px 0px 0px 0px;
  }  
</style>

<script>
  export default {
    name: 'projects',
  };
</script>


// WEBPACK FOOTER //
// Projects.vue?2fdcd2c7